<template>
  <div class="wechat-login-wrapper">
    <div class="qrcode-wrapper">
      <img class="qrcode-img" :src="wechatForm" alt="" />
      <div class="warning-mask" v-if="expireStatus">
        <img
          :src="require('@/assets/image/logindialog/overduewarning.png')"
          alt=""
        />
        <p>二维码已过期</p>
        <el-button type="text" @click="getWechatCode">点击刷新</el-button>
      </div>
      <!-- <div class="decoration" @click="$emit('changeDialogType')">
                <img :src="require('@/assets/image/logindialog/loginswitch.png')">
            </div> -->
    </div>
    <div class="wechat-login-hint-font">首次登录需关注“爱设计作图”公众号</div>
  </div>
</template>

<script>
export default {
  name: "wechatLogin",
  data() {
    return {
      wechatForm: "",
      getWeixinLogin: null,
      expireStatus: false, // 过期后显示过期图片
      loginParams: {
        // 后期用于统计注册操作 来源主要通过url
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
      },
    };
  },
  created() {
    let { utm_source, utm_medium, utm_campaign } = this.$route.query;
    this.loginParams = {
      utm_source: utm_source || "",
      utm_medium: utm_medium || "",
      utm_campaign: utm_campaign || "",
    };
  },
  mounted() {
    this.getWechatCode();
  },
  beforeDestroy() {
    clearInterval(this.getWeixinLogin);
    this.getWeixinLogin = null;
  },
  methods: {
    getWechatCode() {
      let that = this;
      let timeout = 0;
      clearInterval(this.getWeixinLogin);
      this.getWeixinLogin = null;
      //登录参数
      let loginParams = { register_type: 2 };
      //合并utmParams
      var utmParams = localStorage.utmParams
        ? JSON.parse(localStorage.utmParams)
        : {};
      loginParams = Object.assign(loginParams, utmParams);
      loginSdk
        .requestAction("wechat_code", loginParams)
        .then((res) => {
          //code 为0表示成功
          if (res.code == 0) {
            let { sign, url } = res.data;
            this.expireStatus = false;
            this.wechatForm = url;
            that.getWeixinLogin = setInterval(() => {
              getWeixinLoginResult(sign);
            }, 1000);

            function getWeixinLoginResult(sign) {
              var data = { sign: sign };
              var utm_source = "";

              if (localStorage.utmParams) {
                var utmParams = JSON.parse(localStorage.utmParams);
                $.extend(data, utmParams);
                utm_source = utmParams.utm_source;
              }
              loginSdk
                .requestAction("check_weixin_login", data)
                .then((res) => {
                  if (res.code == 0) {
                    clearInterval(that.getWeixinLogin);
                    location.reload();
                  } else {
                    // 登录失败的状态：开始计时，需要判断是否已经过去了300秒，如果大于300秒不再查询接口，并提示二维码失效，重新刷新
                    timeout += 1000;
                    if (timeout >= 1000 * 300) {
                      // 300s 过期时间
                      clearInterval(that.getWeixinLogin);
                      that.expireStatus = true;
                    }
                  }
                })
                .catch((error) => that.catchMessage(err));
            }
          }
        })
        .catch((err) => that.catchMessage(err));
    },
    setLoginData(data) {
      this.$message.success("登录成功");
      this.$store.dispatch("loginInfo").then((res) => {
        if (this.isDialog) {
          window.parent.postMessage({ type: "isLogin", val: data.token }, "*");
          return;
        }
        if (res) {
          let domain = res.current_team_domain;
          if (process.env.VUE_APP_RealmName && domain) {
            // 配置域名
            domain = domain.split(".")[0] + `.${process.env.VUE_APP_RealmName}`;
          }
          if (domain) {
            window.location.href = `https://${domain}`;
          } else {
            this.$router.push({ name: "Team", query: this.$route.query });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wechat-login-wrapper {
  width: 100%;
  padding-top: 21px;

  .qrcode-wrapper {
    position: relative;
    margin: 0 auto 18px;
    width: 240px;
    height: 240px;
    background: #f7f6f9;
    border-radius: 4px;
    text-align: center;

    .qrcode-img {
      position: relative;
      width: 222px;
      margin: 9px;
      z-index: 99;
    }

    .decoration {
      z-index: 1;
      position: absolute;
      width: 33px;
      top: 6px;
      right: 7px;
      cursor: pointer;
      &:before {
        content: "";
        width: 0;
        height: 0;
        border: 26px solid transparent;
        border-bottom: 31px solid #fff;
        border-left: 0;
        position: absolute;
        top: -29px;
      }
      img {
        width: 100%;
      }
    }

    .warning-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid #e7e7e6;
      box-sizing: border-box;
      text-align: center;

      img {
        display: block;
        width: 36px;
        height: 36px;
        margin: 50px auto 10px;
      }

      p {
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #000;
        line-height: 20px;
      }
    }

    /*.decoration {*/
    /*	position: absolute;*/
    /*	width: 17px;*/
    /*	height: 17px;*/
    /*	border: 1px solid #7966ff;*/
    /*	box-sizing: border-box;*/

    /*	&.t {*/
    /*		border-right: 0;*/
    /*		border-bottom: 0;*/
    /*		top: 0;*/
    /*		left: 0;*/
    /*	}*/

    /*	&.r {*/
    /*		border-left: 0;*/
    /*		border-bottom: 0;*/
    /*		top: 0;*/
    /*		right: 0;*/
    /*	}*/

    /*	&.b {*/
    /*		border-left: 0;*/
    /*		border-top: 0;*/
    /*		bottom: 0;*/
    /*		right: 0;*/
    /*	}*/

    /*	&.l {*/
    /*		border-right: 0;*/
    /*		border-top: 0;*/
    /*		bottom: 0;*/
    /*		left: 0;*/
    /*	}*/
    /*}*/
  }

  .wechat-login-hint-font {
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3b3946;
    line-height: 17px;
  }
}
</style>
